const PRESENCE_CONFIG: Record<string, { color: string; label: string }> = {
  online: { color: '#2ea043', label: 'Online' },
  away: { color: '#d29922', label: 'Ausente' },
  busy: { color: '#f85149', label: 'Ocupado' },
  offline: { color: '#6e7681', label: 'Offline' },
}

export function PresenceDot({ status, size = 10, showLabel = false }: { status?: string; size?: number; showLabel?: boolean }) {
  const config = PRESENCE_CONFIG[status ?? 'offline'] ?? PRESENCE_CONFIG.offline

  if (showLabel) {
    return (
      <span className="presence-indicator">
        <span
          className="presence-dot"
          style={{
            width: size,
            height: size,
            backgroundColor: config.color,
          }}
        />
        <span className="presence-label" style={{ color: config.color }}>
          {config.label}
        </span>
      </span>
    )
  }

  return (
    <span
      className="presence-dot"
      style={{
        width: size,
        height: size,
        backgroundColor: config.color,
      }}
      title={config.label}
    />
  )
}
